<template>

  <div class="p-2 container-fluid">
    <div class="row form-row">
      <div class="col-sm-12">
        <div class="card">
          <div class="p-2 card-body">
            <!--
            <div
              class="row form-row list-group-item border-0 d-flex p-3 w-100 d-flex justify-content-center"
            >
              <div class="col-12 text-center">
                <p class="fw-bold text-dark">Escanea el código QR:</p>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="row form-row qr-code-simulation">
                  <div class="qr-border">
                    <img :src="qrCode" class="qrCode" alt="main_logo" />

                  </div>
                </div>
              </div>
            </div>

            
            <div
              class="row form-row list-group-item border-0 d-flex p-3 w-100 d-flex justify-content-center"
            >
              <div class="col-12 text-center">
                <p class="fw-bold text-dark">o</p>
                <p class="fw-bold text-dark">Ingresa al siguiente enlace:</p>
              </div>
              <div class="col-12 text-center">
                <i class="fas fa-link pe-2"></i>
                <a href="https://somospln.com/elector" target="_blank"
                  >https://somospln.com/elector</a
                >
              </div>
            </div>
            

            <hr class="horizontal dark my-2" />
            -->

            <div
              class="row form-row list-group-item border-0 d-flex p-3 w-100 d-flex justify-content-center mb-3"
            >
              <div class="col-12 text-center">
                <router-link :to="{ name: 'Formulario Elector' }">
                  <argon-button
                    class="mt-0 btn-lg py-4 px-2 text-lg"
                    color="success"
                    full-width
                  >
                    <i class="fas fa-user-plus pe-2"></i> Registrar Nuevo
                    Elector
                  </argon-button>
                </router-link>
              </div>
            </div>
            
            <data-tables v-if="userRole === 'usuario'"  
              :key="tableKey" 
              :applyFilters="true" 
              :isColaborador="true"
            />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArgonButton from "@/components/ArgonButton.vue";
import qrCode from "@/assets/qrcode.jpg";
import DataTables from "@/views/main/components/DataTables.vue";
import { onBeforeMount, onBeforeUnmount, onMounted } from "vue";
import { useStore } from "vuex";
const store = useStore();
const userRole = sessionStorage.getItem("usuarioRol"); // Get the role from sessionStorage

const onlyShowNavBar = () => store.commit("onlyShowNavBar");


/*onBeforeMount(() => {
  store.dispatch("setConfigButtonVisibility", true);
  store.commit("navbarMinimize");
  const userRole = sessionStorage.getItem("usuarioRol");

   if (userRole && userRole === 'administrador' || userRole === 'dueno') {    
    store.state.showNavbar = true;
    store.state.showSidenav = true;

  }else if (userRole === 'usuario'){
    store.state.showNavbar = true;
    store.state.showSidenav = true;

  }
});*/

onBeforeUnmount(() => {
  store.dispatch("setConfigButtonVisibility", false);
  //onlyShowNavBar(); //Elimina sidebar y footer
});

</script>

<style>
.form-row {
  --bs-gutter-x: none !important;
}

.list-group-item:first-child {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}

.table-responsive {
  margin-top: 20px;
}

.table th,
.table td {
  text-align: center;
  font-size: 14px;
}

.qr-border {
  width: 90%;
}
.qr-code-simulation .qr-border {
  border: 5px solid #4b4b4b;
  border-radius: 8px;
}

.qr-code-simulation .qr-border p {
  font-size: 14px;
  color: #4b4b4b;
  margin-top: 50%;
  transform: translateY(-50%);
}

.qrCode{
  width: 100%;
  height: 100%;
}
</style>
